module.exports = __webpack_public_path__ + "img/india.16fcb0a6.svg";